import { connect } from 'react-redux';
import { closeModal } from 'common/src/app/actions/components/modalActions';
import InstagramImageModal from './InstagramImageModal';

export default connect(null, { closeModal })(InstagramImageModal);
